import formatName from 'I18n/utils/formatName';
import I18n from 'I18n';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Media, MediaBody, MediaLeft } from 'foundations-components/transitional/components/Media';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UISimpleAvatar = Loadable({
  loader: () =>
  // @ts-expect-error Library not yet migrated
  import( /* webpackChunkName: "bundles/avatars" */'ui-addon-avatars').then(mod => mod.UIAvatar)
});
const socialMediaNamesMap = {
  x: 'X',
  linkedin: 'LinkedIn'
};
const SocialLink = ({
  type,
  url
}) => {
  return url ? /*#__PURE__*/_jsx(Link, {
    external: true,
    href: url,
    children: socialMediaNamesMap[type]
  }) : null;
};
const ProfessorRow = ({
  id,
  name,
  description,
  image,
  xUrl,
  linkedinUrl,
  jobTitle,
  organisation,
  organisationUrl,
  handleOrganisationUrlClick
}) => {
  return /*#__PURE__*/_jsxs(Media, {
    children: [/*#__PURE__*/_jsx(MediaLeft, {
      children: /*#__PURE__*/_jsx(UISimpleAvatar, {
        alt: I18n.text('learningCenter.lessonInformation.professorPictureAltText', {
          name: formatName({
            name
          })
        }),
        shape: "circle",
        size: "lg",
        src: image
      })
    }), /*#__PURE__*/_jsxs(MediaBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginBlockEnd: "0",
        children: name
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "0",
        children: jobTitle
      }), organisationUrl && organisation ? /*#__PURE__*/_jsx(Link, {
        external: true,
        href: organisationUrl,
        onClick: handleOrganisationUrlClick(id, organisation, organisationUrl),
        children: organisation
      }) : /*#__PURE__*/_jsx("p", {
        children: organisation
      }), /*#__PURE__*/_jsx("p", {
        children: description
      }), /*#__PURE__*/_jsx(SocialLink, {
        type: "x",
        url: xUrl
      }), /*#__PURE__*/_jsx(SocialLink, {
        type: "linkedin",
        url: linkedinUrl
      })]
    })]
  });
};
export default ProfessorRow;